module.exports = __webpack_public_path__ + "img/bicycle-green-right.e75f4654.jpg";